import { CommonHeading } from '~/components/flp/Financing.styles';
import Section from '~/components/flp/Section';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import ReviewCard from './ReviewCard';
import { Container, ReviewsSection } from './Reviews.styles';

const reviews = [
  {
    date: 'July 2025',
    location: 'from GA',
    rating: 5,
    text: '“The whole process was very smooth [from] applying, to selecting the car we wanted. I really liked how clear and accurate the monthly payment would be.”',
    user: 'Brian S.'
  },
  {
    date: 'July 2025',
    location: 'from CA',
    rating: 5,
    text: '“This is my second purchase and this time I had a trade in that had negative equity. The dealerships shamed me for this, but not Carvana! I received the best offer for my trade...Carvana is a game changer and THE best option to purchase a car.”',
    user: 'Catrice B.'
  },
  {
    date: 'January 2024',
    location: 'from TX',
    rating: 5,
    text: '“This entire process was so easy and helpful! They let you determine how much you can afford a month and then present vehicles to you in that range. ZERO hassle. All the numbers are there for you to make the right financial decision for yourself!”',
    user: 'Keith K.'
  }
];

export default function Reviews() {
  return (
    <Section
      as={ReviewsSection}
      eventName={ANALYTICS_EVENTS.MARKETING.SECTION_VIEWED_REVIEWS}
    >
      <CommonHeading>Real customers. Real Reviews. Real Happy.</CommonHeading>
      <Container>
        {reviews.map(review => (
          <ReviewCard key={review.user} {...review} />
        ))}
      </Container>
    </Section>
  );
}
